import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { REDUX_STORE_SLICES } from '../../services/exports/Constants';
import { SliceCaseReducers } from '@reduxjs/toolkit/dist/createSlice';
import { GiftCard } from '../../services/exports/Interfaces';
import { StoreInterface } from '../types';

type InitialState = Readonly<{
  item?: GiftCard;
}>;

const initialState: InitialState = {
  item: undefined,
} as const;

const giftCardSlice = createSlice<InitialState, SliceCaseReducers<InitialState>>({
  name: REDUX_STORE_SLICES.GIFT_CARD,
  initialState,
  reducers: {
    apply: (state, action: PayloadAction<GiftCard>) => {
      state.item = action.payload;
    },
  },
});

export const selectGiftCard = (state: StoreInterface) => state[REDUX_STORE_SLICES.GIFT_CARD].item;

export default giftCardSlice;
